// Translation: Turkish > Actions
const actions = Object.freeze({
	refreshPage: 'Sayfayı yenile',
	startOver: 'Baştan başla'
})

// Export
export default actions
